import type { Practitioner, Reference } from '@medplum/fhirtypes'
import type { ExtendedObservation } from '@seen/core/models/observation'

// Puts a note written before the vital was recorded onto the new record,
// alongside its value line.
export function withClinicianNote(
  note: string,
  author: Reference<Practitioner>,
  observation: ExtendedObservation
): ExtendedObservation {
  observation.setClinicianNote(note, author)
  return observation
}
